module.exports = __webpack_public_path__ + "static/logo-8fe34043fb96d58a991170a33702a469.svg";